import { Level } from '../../types/level'

export const levelStyles: Record<Level, { style: string; iconColor: string; textColor: string }> = {
	silver: {
		style: '!border-[#9c9c9c] bg-gradient-to-r from-[#c4c4c4] via-[#d6d6d6] to-[#a5a5a5]',
		iconColor: 'text-[#8a8a8a]',
		textColor: 'text-[#4f4f4f]',
	},
	gold: {
		style: '!border-[#a1895cd9] bg-gradient-to-r from-[#DDC590] via-[#ece2cb] to-[#c1a976]',
		iconColor: 'text-[#937a44]',
		textColor: 'text-[#6A5E44]',
	},
	platinum: {
		style: 'border-[#cdd2d9] bg-gradient-to-r from-[#e4e8ef] via-[#f7f9fc] to-[#d0d8e2]',
		iconColor: 'text-[#a0a9b3]',
		textColor: 'text-[#5a5f66]',
	},
	noLevel: {
		style: '!border-dashed !border-[#c4c4c4] bg-[#f5f5f5]',
		iconColor: 'text-text-dark',
		textColor: 'text-text-dark',
	},
}
